import request from '@/utils/request'

// 查询销售合同台账列表
export function listXshttz(query) {
  return request({
    url: '/xm/xshttz/list',
    method: 'get',
    params: query
  })
}

// 查询销售合同台账列表
export function xzXshtList(query) {
  return request({
    url: '/xm/xshttz/xzlist',
    method: 'get',
    params: query
  })
}
// 查询销售合同台账详细
export function getXshttz(id) {
  return request({
    url: '/xm/xshttz/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/xm/xshttz.js